<script lang="ts">
    import {onDestroy} from 'svelte'
    import KnownLearnRemove from './WordCard/KnownLearnRemove.svelte';
    import Sentences from './WordCard/Sentence/Sentences.svelte';
    import WordCount from './WordCard/WordCount.svelte';
    import WordFacts from './WordCard/WordFacts.svelte';
    import {ASSETS_HOST} from '../../../consts';
    import {goto} from '$app/navigation';
    // noinspection ES6UnusedImports
    import {page} from '$app/state';
    import Translation from '$lib/components/browse/WordCard/Translation.svelte';
    import type {WordIdToSentences} from '$lib/data/wordIdToSentences';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import type {FilterSettings} from '$lib/stores/filterSettings';
    import type {LoggedIn} from '$lib/classes/stores/logged-in';
    import {Noun} from '$lib/classes/data/word';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import type {Device} from '$lib/stores/ui/device';

    export let currentWord: CurrentWord
    export let wordIdToSentences: WordIdToSentences
    export let userWordsMap: UserWordsMapStore
    export let filterSettings: FilterSettings
    export let loggedIn: LoggedIn
    export let device: Device

    $: cW = $currentWord!
    $: id = cW.id
    $: art = cW.art
    $: frequency = cW.base.frequency
    $: word = cW.base.displayWord && !$filterSettings.syllables ? cW.base.displayWord.split(', ') :
        $filterSettings.syllables ? [cW.syllStr] :
            [cW.word]
    $: translations = cW.base.translations
    $: phonetic = cW.base.phonetic
    $: plural = cW instanceof Noun ? cW.plural : null
    $: imgNr = cW.base.imgNr

    $: userWord = $userWordsMap[id]

    $: sentences = wordIdToSentences[id] ?? []

    let firstRowHeight = 170
    let scrollTop = 0
    $: hideFirst = scrollTop > 20
    $: hideSecond = scrollTop > (firstRowHeight - 45)

    let cardWrapper: HTMLDivElement
    // QUESTION why not rerender whole component via #key ?!
    const unsubCurrentWord = currentWord.subscribe(_ => {
        if (cardWrapper) cardWrapper.scrollTop = 0
    })
    onDestroy(unsubCurrentWord)

    function handleScroll(event: Event) {
        const target = event.target as HTMLElement
        scrollTop = target.scrollTop
    }
</script>

<div id="card-wrapper" bind:this={cardWrapper}
     data-testid="word-card"
     style:grid-template-rows="{firstRowHeight}px min-content auto"
     style={`--color-accent: var(--color-${art});`}
     class="styled-scrollbars"
     on:scroll={handleScroll}
>

    {#if !$loggedIn}
        <div id="login-btns" class="save-login-btns">
            <div id="test-mode">
                <span id="test-mode-text">
                    ⚠️ <b> Test mode</b> ~ <b>to save changes</b>
                </span>
                »
                <a href="#0" id="word-card-sign-in-link"
                   on:click|preventDefault={() => goto('/signin', {state: {url: `${page.url.href}`}})}
                >
                    Sign in
                </a>
            </div>
        </div>
    {/if}

    <div id="facts" class="top"
         class:fade-out={hideFirst}
    >
        <WordFacts
                art={art}
                frequency={frequency}
                level={cW.base.level}
                phonetic={phonetic}
                plural={plural}
        />
    </div>

    <div id="word-img-wrapper" class="top">
        {#if imgNr}
            <img src={`${ASSETS_HOST}/img/100/${imgNr}.jpg`} alt="" class="word-img"
                 class:hide-image={hideFirst}
                 data-testid="word-card-word-image"
            >
        {/if}
    </div>

    <div id="upper-right-btns" class="top">
        <div id="save-btns" class="save-login-btns">
            <WordCount scrolled={hideFirst}
                       savedWordsCount={Object.values($userWordsMap).length}
            />
            <KnownLearnRemove
                    {id}
                    {userWord}
            />
        </div>
    </div>

    <div id="translation-wrapper"
         class:fade-out={hideSecond}
    >

        <Translation
                currentWord={currentWord}
                word={word}
                translations={translations}
                filterSettings={filterSettings}
                device={device}
        />

    </div>

    {#key $currentWord}
        <Sentences
                currentWord={currentWord}
                userWordsMap={userWordsMap}
                {sentences}
                {userWord}
        />
    {/key}

    <!--    <div id="show-help-wrapper">-->
    <!--        <ShowHelp/>-->
    <!--    </div>-->

</div>


<style>
    .fade-out {
        opacity: 0;
    }

    #card-wrapper {
        --padding: 34px;
        position: relative;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-y: scroll;
        overflow-x: hidden;
        /*border: 1px solid darkolivegreen;*/
    }

    .top {
        width: max-content;
        box-sizing: border-box;
        padding-bottom: 0;
        margin: 0;
        overflow: visible;
        /*border: 1px solid darkmagenta;*/
    }

    #facts {
        /*noinspection CssInvalidPropertyValue*/
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        transition: var(--transition);
        padding-left: var(--padding);
        padding-top: var(--padding);
        /*border: 1px solid magenta;*/
    }

    #upper-right-btns {
        /*noinspection CssInvalidPropertyValue*/
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        right: 0;
        margin-left: auto;
        display: flex;
        padding-top: var(--padding);
        padding-right: var(--padding);
        z-index: var(--z-index-word-card-rate-btns);
        /*border: 1px solid orangered;*/
    }

    .save-login-btns {
        text-align: right;
    }

    #save-btns {
        margin-left: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        /*border: 1px solid teal;*/
    }

    #login-btns {
        position: fixed;
        top: 0;
        right: var(--scrollbar-width);
        width: calc((100vw - 270px) * .55 - var(--scrollbar-width));
        padding: .1rem 0 .2rem 0;
        display: grid;
        place-content: center flex-end;
        grid-template-columns: max-content var(--padding);
        align-items: center;
        transition: var(--transition);
        z-index: var(--z-index-word-card-login-btns);
        background: #faf1de;
        /*border: 1px solid teal;*/
    }

    #test-mode {
        position: relative;
        cursor: default;
        /*border: 1px solid blue;*/
    }

    #test-mode-text {
        font-size: .85rem;
        color: #996402;
        /*margin-right: .1rem;*/
    }

    #word-card-sign-in-link {
        color: var(--color-main);
        font-size: .95rem;
        font-weight: var(--font-emph);
    }

    #word-img-wrapper {
        margin: 0 auto;
        /*noinspection CssInvalidPropertyValue*/
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 70px;
        /*border: 1px solid teal;*/
    }

    .word-img {
        border-radius: var(--border-radius);
        width: 100px;
        height: 100px;
        opacity: 1;
        transition: var(--transition);
    }

    .hide-image {
        height: 0;
        opacity: 0;
    }

    #translation-wrapper {
        grid-column: 1/4;
        display: flex;
        width: 100%;
        min-height: 11rem;
        padding: 2rem 0 3.5rem 0;
        transition: opacity 300ms;
        /*border: 1px solid darkmagenta;*/
    }

    @media (prefers-color-scheme: dark) {
        #login-btns {
            background: #785719;
        }

        #test-mode-text {
            color: #bfa575;
        }
    }

</style>